'use strict';
angular.module('smartorg.r6.cmpts.phoneNumber').directive('phoneNumberKit', [function () {
        return {
            restrict: 'E',
            template: require('../../template/phone-number.html'),
            scope: {
                phoneNumber: '=?',
                ext: '=?',
                valid: '=?',
                onChange: '&?'
            },
            link: function (scope) {
                scope.mainValid = true;
                scope.extValid = true;
                /**
                 * Set the phone number to a value and set it to value.
                 *
                 * @param phone {string} Phone number in certain format.
                 *     example: +14082223333.
                 * @param ext {string} Extension.
                 */
                scope.setPhone = function (phone, ext) {
                    if (phone) {
                        var phoneInput = $("#phoneInput");
                        phoneInput.intlTelInput("setNumber", phone, intlTelInputUtils.numberFormat.NATIONAL);
                    }
                    if (ext) {
                        $("#phoneExtInput").val(ext);
                    }
                };
                /**
                 * Clear the phone number input.
                 */
                scope.clearPhone = function () {
                    $("#phoneInput").val('');
                    $("#phoneExtInput").val('');
                };
                /**
                 * Check if phone number is valid and return phone
                 * number.
                 *
                 * @returns {string} If is valid, returns the phone number.
                 *     Otherwise return undefined.
                 */
                scope.checkMain = function () {
                    var phoneInput = $("#phoneInput");
                    var intlNumber = phoneInput.intlTelInput("getNumber");
                    scope.mainValid = true;
                    if (intlNumber) {
                        scope.mainValid = phoneInput.intlTelInput("isValidNumber");
                        if (scope.mainValid) {
                            phoneInput.intlTelInput("setNumber", intlNumber, intlTelInputUtils.numberFormat.NATIONAL);
                        }
                        else {
                            console.error(phoneInput.intlTelInput("getValidationError"));
                        }
                    }
                    return scope.mainValid ? intlNumber : "";
                };
                /**
                 * Check if extension is valid. Should only be numbers.
                 *
                 * @returns {string}
                 */
                scope.checkExt = function () {
                    var ext = $("#phoneExtInput").val();
                    scope.extValid = /^\d*$/.test(ext);
                    return scope.extValid ? ext : "";
                };
                scope.$watchGroup(['phoneNumber', 'ext'], function (newVal, oldVal) {
                    if (newVal[0] !== oldVal[0] || newVal[1] !== oldVal[1]) {
                        if (!newVal[0] && !newVal[1]) {
                            scope.clearPhone();
                        }
                        else {
                            scope.setPhone(newVal[0], newVal[1]);
                        }
                    }
                });
                /**
                 * Let the address book directive get these values.
                 */
                scope.emitPhone = function () {
                    scope.phoneNumber = scope.checkMain();
                    scope.ext = scope.checkExt();
                    scope.valid = scope.mainValid && scope.extValid ? 1 : 2;
                    if (scope.valid && !scope.phoneNumber && !scope.ext) {
                        scope.valid = 0;
                    }
                    if (scope.onChange) {
                        scope.onChange();
                    }
                };
                $("#phoneInput").intlTelInput();
            }
        };
    }]);
//# sourceMappingURL=phone-directive.js.map


// WEBPACK FOOTER //
// ./app/components/phone-number/app/js/plumbing/phone-directive.js